import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { strategyApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';
import type { StrategyStatus } from '../types/strategy';

interface UpdateStatusVariables {
  id: string;
  status: StrategyStatus;
}

export function useUpdateStrategyStatus() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: UpdateStatusVariables) =>
      strategyApi.updateStrategyStatus(variables.id, variables.status),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.strategies.detail(variables.id) });
      queryClient.invalidateQueries({ queryKey: queryKeys.strategies.lists() });

      const message =
        variables.status === 'published'
          ? 'Strategy published successfully'
          : 'Strategy archived successfully';
      toast.success(message);
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to update strategy status');
    },
  });
}
